import { OBSTACLE_TYPE } from "./../ENUM.js";
import * as SOUND_DATA from "./../SOUND_DATA.js";

export const MERNG = {
  isDark: false,
  startHealth: 25,
  timeAllowedSecs: 50,
  textColor: "#01857f",
  textColorHighlight: "#ff0000",
  bgColor: "#ffffff",
  bgFadeAlpha: 0.45,
  gameplayAreaToCanvasLateralRatio: 0.8,
  player: {
    color: "#aad0d7",
    growthDivisor: 2000,
    radius: 15,
  },
  obstacles: [
    {
      type: OBSTACLE_TYPE.BACKGROUND,
      total: 200,
      color_ar: ["#cc0000"],
      radiusRange: [1, 2],
      directionRange: [175, 185],
      speedRange: [0.001, 0.004],
    },
    {
      type: OBSTACLE_TYPE.COLLECT,
      collectSfx_ar: SOUND_DATA.ORDERED_TWANG_SFX_AR,
      total: 100,
      color_ar: ["#fcb7eb"],
      radiusRange: [30, 55],
      directionRange: [120, 240],
      speedRange: [1, 3],
      gradientFadePoint: 0.1,
    },
    {
      type: OBSTACLE_TYPE.COLLECT,
      collectSfx_ar: SOUND_DATA.ORDERED_TWANG_SFX_AR,
      total: 100,
      color_ar: ["#ff469c"],
      radiusRange: [30, 55],
      directionRange: [120, 240],
      speedRange: [1, 3],
      gradientFadePoint: 0.1,
    },
    {
      type: OBSTACLE_TYPE.AVOID,
      total: 2,
      color_ar: ["#16c1c4"],
      radiusRange: [30, 55],
      directionRange: [120, 240],
      speedRange: [1, 3],
    },
    {
      type: OBSTACLE_TYPE.COLLECT,
      collectSfx_ar: SOUND_DATA.ORDERED_TWANG_SFX_AR,
      total: 100,
      color_ar: ["#ff01c0"],
      radiusRange: [30, 55],
      directionRange: [120, 240],
      speedRange: [1, 3],
      gradientFadePoint: 0.1,
    },
    {
      type: OBSTACLE_TYPE.COLLECT,
      collectSfx_ar: SOUND_DATA.ORDERED_TWANG_SFX_AR,
      total: 100,
      color_ar: ["#e046ff"],
      radiusRange: [30, 55],
      directionRange: [120, 240],
      speedRange: [1, 3],
      gradientFadePoint: 0.1,
    },
  ],
};
